module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="header-container">\n	';
 if (!is_off_season) { 
__p+='\n		<a href="javascript:void(0)" class="ion-android-menu main-menu-button hidden-desktop js-open-main-menu"></a>\n	';
 } 
__p+='\n	<a href="/" class="main-logo '+
((__t=( is_off_season ? "off-season-title" : "" ))==null?'':_.escape(__t))+
'">\n		';
 if (!is_off_season) { 
__p+='\n			<picture>\n				<img src="/assets/images/NRLTippingLogo.png" alt="NRLTipping" />\n			</picture>\n		';
 } else { 
__p+='\n			<picture>\n				<img src="/assets/images/NRLTippingLogoOffSeason.svg" alt="NRLTipping" class="off-season-logo" />\n			</picture>\n		';
 } 
__p+='\n	</a>\n	<div class="info-section">\n		';
 if (!is_off_season && is_show_sponsor) { 
__p+='\n			<div class="sports-bet-header-block hidden-mobile">\n				Presented By\n				<div class="logo">\n					<img src="/assets/images/sports-bet-logo-header.jpg?v=1" alt="SportsBet.com.au" />\n				</div>\n			</div>\n		';
 } 
__p+='\n	</div>\n</div>\n';
 if (!is_off_season && is_show_sponsor) { 
__p+='\n	<div class="sports-bet-header-block hidden-desktop">\n		Presented By\n		<div class="logo">\n			<img src="/assets/images/sports-bet-logo-header.jpg" alt="SportsBet.com.au" />\n		</div>\n		\n	</div>\n\n	<div id="menu"></div>\n';
 } 
__p+='\n';
}
return __p;
};
